import { render, staticRenderFns } from "./ChamberToday.vue?vue&type=template&id=2529fcea"
import script from "./ChamberToday.vue?vue&type=script&lang=js"
export * from "./ChamberToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports